import { Link } from 'react-router-dom'

import Logo from '../assets/logos/logo-header.png'
import HugcareLogo from '../assets/icons/hugcare-logoIcon_orange.svg'

export function ContactSubmitModal({ isSubmit, setModalOpen }) {
  const closeModal = () => {
    setModalOpen(false)
  }

  return (
    <div className='z-[999] w-full h-full bg-neutral-99 bg-opacity-80 fixed top-0 left-0 flex justify-center items-center overflow-auto'>
      {isSubmit && (
        <div className='w-[300px] 2xs:w-[440px] sm:w-[640px] lg:w-[840px] bg-sk-white rounded-20 flex flex-col justify-center items-center gap-32 2xs:gap-64 px-32 pt-60 2xs:pt-80 pb-36 2xs:pb-48'>
          <div className='flex flex-col items-center gap-20'>
            <img className='w-[90px] h-36' src={Logo} alt='' />
            <div className='flex flex-col items-center gap-8'>
              <p className='text-center title-h1-semibold 2xs:text-title3-medium sm:text-title2-medium text-sk-default'>
                시그마테크놀로지에 <br className='sm:hidden' />
                관심을 가져주셔서 감사합니다
              </p>
              <p className='title-h1-semibold 2xs:text-title3-medium sm:text-title2-medium text-sk-default'>
                3영업일 이내 연락드리겠습니다
              </p>
            </div>
          </div>
          <Link
            to='/'
            className='py-12 2xs:py-16 px-36 2xs:px-48 button_black text-sk-white'
            onClick={closeModal}
          >
            확인
          </Link>
        </div>
      )}
    </div>
  )
}
export function HugcareSubmitModal({ isSubmit, setModalOpen }) {
  const closeModal = () => {
    setModalOpen(false)
  }

  return (
    <div className='z-[999] w-full h-full bg-neutral-99 bg-opacity-80 fixed top-0 left-0 flex justify-center items-center overflow-auto'>
      {isSubmit && (
        <div className='w-[300px] 2xs:w-[440px] sm:w-[640px] lg:w-[840px] bg-sk-white rounded-20 flex flex-col justify-center items-center gap-32 2xs:gap-64 px-32 pt-60 2xs:pt-80 pb-36 2xs:pb-48'>
          <div className='flex flex-col items-center gap-20'>
            <img className='w-[90px] h-36' src={Logo} alt='' />
            <div className='flex-col items-center gap-8 sm:flex'>
              <div className='flex items-center max-sm:flex-col sm:gap-8'>
                <div className='flex items-center'>
                  <div className='flex items-center justify-center gap-8'>
                    <img src={HugcareLogo} alt='' />
                    <span className='2xs:text-title3-bold sm:text-title2-bold text-sk-hugcare'>
                      허그케어
                    </span>
                  </div>
                  <span className='title-h1-semibold 2xs:text-title3-medium sm:text-title2-medium text-sk-default'>
                    에
                  </span>
                </div>
                <span className='title-h1-semibold 2xs:text-title3-medium sm:text-title2-medium text-sk-default'>
                  관심을 가져주셔서 감사합니다
                </span>
              </div>
              <p className='title-h1-semibold 2xs:text-title3-medium sm:text-title2-medium text-sk-default'>
                3영업일 이내 연락드리겠습니다
              </p>
            </div>
          </div>
          <button
            type='button'
            className='py-12 2xs:py-16 px-36 2xs:px-48 button_black text-sk-white'
            onClick={closeModal}
          >
            확인
          </button>
        </div>
      )}
    </div>
  )
}
